// // // // // src/App.js
// // // // import React, { Suspense, lazy } from "react";
// // // // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// // // // import Nav from "./components/Nav";
// // // // import ScrollToTop from "./components/ScrollToTop";
// // // // import Modal from "react-modal";
// // // // import Footer from "./components/footer";

// // // // // ✅ Profile subpages
// // // // import OrdersPagep from "./pages/profile/OrdersPagep";
// // // // import Cartp from "./pages/profile/Cartp";
// // // // import LikedPagep from "./pages/profile/LikedPagep";
// // // // import Couponsp from "./pages/profile/Couponsp";
// // // // import TermsAnsConditions from "./pages/TermsAndConditions";
// // // // import HelpSupports from "./pages/HelpSupports";

// // // // // ✅ Admin/Employee imports
// // // // import LoginPage from "./component/LoginPage";
// // // // import Dashboard from "./component/Dashboard";
// // // // import OrdersPage from "./component/OrdersPage/OrdersPage";
// // // // import AddServicesPage from "./component/AddServicesPage/AddServicesPage";
// // // // import CustomersPage from "./component/CustomersPage/CustomersPage";
// // // // import FeedbackPage from "./component/FeedbackPage/FeedbackPage";
// // // // import SettingsPage from "./component/SettingsPage/SettingsPage";
// // // // import EmployeesPage from "./component/EmployeesPage/EmployeesPage";
// // // // import EmployeeDashboard from "./component/EmployeeDashboard/EmployeeDashboard";
// // // // import AssignedWork from "./component/EmployeeDashboard/Work/AssignedWork";
// // // // import Workcompleted from "./component/EmployeeDashboard/Work/Workcompleted";
// // // // import ProtectedRoute from "./component/ProtectedRoute";
// // // // import Specialoffer from "./pages/Specialoffer";
// // // // import ChangeLocation from "./pages/subpages/ChangeLocation";
// // // // import SavedLocations from "./pages/subpages/SavedLocations";
// // // // import ChangeLocationManually from "./pages/subpages/ChangeLocationManually";
// // // // import AddAdmin from "./component/EmployeesPage/AddAdmin";
// // // // import LocationPicker from "./pages/subpages/LocationPicker";
// // // // import OrderDetails1 from "./component/EmployeeDashboard/Work/OrderDetails1";
// // // // import AssignedWorkDetail from "./component/EmployeeDashboard/Work/AssignedWorkDetail";

// // // // Modal.setAppElement("#root");

// // // // // ✅ Lazy load pages
// // // // const Home = lazy(() => import("./pages/Home"));
// // // // const ServiceHome = lazy(() => import("./pages/servicehome"));
// // // // const SubHome = lazy(() => import("./pages/subhome"));
// // // // const OfferCard = lazy(() => import("./pages/offercard"));
// // // // const OfferCard2 = lazy(() => import("./pages/offercard2"));
// // // // const AllSubServices = lazy(() => import("./pages/AllSubServices"));
// // // // const ServiceDetails = lazy(() => import("./pages/ServiceDetails"));
// // // // const Login = lazy(() => import("./pages/Login"));

// // // // // ✅ Like system
// // // // const LikePage = lazy(() => import("./pages/Like"));
// // // // const LikedPage = lazy(() => import("./pages/Likes/LikedPage"));
// // // // const CartPage = lazy(() => import("./pages/Cart/Cart"));
// // // // const OrdersPageMain = lazy(() => import("./pages/Orders/Order"));
// // // // const CompletedOrdersPage = lazy(() =>
// // // //   import("./pages/CompletedOrder/CompletedOrders")
// // // // );

// // // // // ✅ Profile system
// // // // const Profile = lazy(() => import("./pages/Profile"));
// // // // const Wallet = lazy(() => import("./pages/profile/Wallet"));
// // // // const Wishlist = lazy(() => import("./pages/profile/Wishlist"));
// // // // const Coupons = lazy(() => import("./pages/profile/Coupons"));
// // // // const EditProfile = lazy(() => import("./pages/profile/EditProfile"));
// // // // const HelpSupport = lazy(() => import("./pages/profile/HelpSupport"));
// // // // const PrivacyPolicy = lazy(() => import("./pages/profile/PrivacyPolicy"));

// // // // // ✅ Subpages (About section)
// // // // const CompanyOverview = lazy(() => import("./Subpages/CompanyOverview"));
// // // // const Leadership = lazy(() => import("./Subpages/Leadership"));

// // // // function App() {
// // // //   return (
// // // //     <Router>
// // // //       <ScrollToTop />
// // // //       <Nav />

// // // //       <div className="main-content" style={{ paddingTop: "70px" }}>
// // // //         <Suspense fallback={<div className="loader">Loading...</div>}>
// // // //           <Routes>
// // // //             {/* ================== Main User Routes ================== */}
// // // //             <Route path="/" element={<Home />} />
// // // //             <Route path="/servicehome" element={<ServiceHome />} />
// // // //             <Route path="/Address" element={<SavedLocations />} />
// // // //             <Route path="/LocationPicker" element={<LocationPicker />} />
// // // //             <Route path="/ChangeLocationManually" element={<ChangeLocationManually />} />
// // // //             <Route path="/ChangeLocation" element={<ChangeLocation />} />
// // // //             <Route path="/subhome/:category" element={<SubHome />} />
// // // //             <Route path="/offercard" element={<OfferCard />} />
// // // //             <Route path="/offercard2/:offerId" element={<OfferCard2 />} />
// // // //             <Route path="/allservices" element={<AllSubServices />} />
// // // //             <Route path="/allservices/:offer_id" element={<ServiceDetails />} />
// // // //             <Route path="/login" element={<Login />} />
// // // //             <Route path="/termsandconditions" element={<TermsAnsConditions />} />
// // // //             <Route path="/HelpSupports" element={<HelpSupports />} />
// // // //             <Route path="/specialoffer" element={<Specialoffer />} />

// // // //             {/* About */}
// // // //             <Route path="/about/company" element={<CompanyOverview />} />
// // // //             <Route path="/about/leadership" element={<Leadership />} />

// // // //             {/* Like system */}
// // // //             <Route path="/like" element={<LikePage />} />
// // // //             <Route path="/like/liked" element={<LikedPage />} />
// // // //             <Route path="/like/cart" element={<CartPage />} />
// // // //             <Route path="/like/orders" element={<OrdersPageMain />} />
// // // //             <Route path="/like/completedorders" element={<CompletedOrdersPage />} />

// // // //             {/* Profile with nested routes */}
// // // //             <Route path="/profile" element={<Profile />}>
// // // //               <Route path="orders" element={<OrdersPagep />} />
// // // //               <Route path="cart" element={<Cartp />} />
// // // //               <Route path="liked" element={<LikedPagep />} />
// // // //               <Route path="coupons" element={<Couponsp />} />
// // // //               <Route path="wallet" element={<Wallet />} />
// // // //               <Route path="wishlist" element={<Wishlist />} />
// // // //               <Route path="editprofile" element={<EditProfile />} />
// // // //               <Route path="support" element={<HelpSupport />} />
// // // //               <Route path="privacy" element={<PrivacyPolicy />} />
// // // //               <Route path="footer" element={<Footer />} />
// // // //               <Route path="changelocation" element={<ChangeLocation />} />
// // // //               <Route path="offers" element={<ChangeLocation />} />
// // // //             </Route>

// // // //             {/* ================== Admin / Employee Routes ================== */}
// // // //             <Route path="/admin-login" element={<LoginPage />} />
// // // //             <Route
// // // //               path="/admin-dashboard"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <Dashboard />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/orders"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <OrdersPage />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/employees"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <EmployeesPage />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/AddAdmin"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <AddAdmin />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/add-services"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <AddServicesPage />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/customers"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <CustomersPage />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/feedback"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <FeedbackPage />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/settings"
// // // //               element={
// // // //                 <ProtectedRoute type="owner">
// // // //                   <SettingsPage />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />

// // // //             {/* Employee Routes */}
// // // //             <Route
// // // //               path="/employee-dashboard"
// // // //               element={
// // // //                 <ProtectedRoute type="employee">
// // // //                   <EmployeeDashboard />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/work"
// // // //               element={
// // // //                 <ProtectedRoute type="employee">
// // // //                   <AssignedWork />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //             <Route
// // // //               path="/assigned-work/:id"
// // // //               element={
// // // //                 <ProtectedRoute type="employee">
// // // //                   <AssignedWorkDetail />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />

// // // //             <Route
// // // //               path="/worked"
// // // //               element={
// // // //                 <ProtectedRoute type="employee">
// // // //                   <Workcompleted />
// // // //                 </ProtectedRoute>
// // // //               }
// // // //             />
// // // //           </Routes>
// // // //         </Suspense>
// // // //       </div>
// // // //     </Router>
// // // //   );
// // // // }

// // // // export default App;



// // // import React, { Suspense, lazy } from "react";
// // // import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// // // import ScrollToTop from "./components/ScrollToTop";
// // // import Modal from "react-modal";
// // // import Nav from "./components/Nav";
// // // import Footer from "./components/footer";

// // // // Admin/Employee imports
// // // import LoginPage from "./component/LoginPage";
// // // import Dashboard from "./component/Dashboard";
// // // import OrdersPage from "./component/OrdersPage/OrdersPage";
// // // import AddServicesPage from "./component/AddServicesPage/AddServicesPage";
// // // import CustomersPage from "./component/CustomersPage/CustomersPage";
// // // import FeedbackPage from "./component/FeedbackPage/FeedbackPage";
// // // import SettingsPage from "./component/SettingsPage/SettingsPage";
// // // import EmployeesPage from "./component/EmployeesPage/EmployeesPage";
// // // import EmployeeDashboard from "./component/EmployeeDashboard/EmployeeDashboard";
// // // import AssignedWork from "./component/EmployeeDashboard/Work/AssignedWork";
// // // import Workcompleted from "./component/EmployeeDashboard/Work/Workcompleted";
// // // import ProtectedRoute from "./component/ProtectedRoute";
// // // import AssignedWorkDetail from "./component/EmployeeDashboard/Work/AssignedWorkDetail";
// // // import AddAdmin from "./component/EmployeesPage/AddAdmin";

// // // Modal.setAppElement("#root");

// // // // Lazy load other pages
// // // const Home = lazy(() => import("./pages/Home"));
// // // const ServiceHome = lazy(() => import("./pages/servicehome"));
// // // // ... (all other lazy imports remain same)

// // // // Wrapper to conditionally render Nav
// // // function LayoutWrapper({ children }) {
// // //   const location = useLocation();

// // //   // List of paths where Nav should NOT appear
// // //   const hideNavPaths = [
// // //     "/admin-login",
// // //     "/admin-dashboard",
// // //     "/orders",
// // //     "/employees",
// // //     "/AddAdmin",
// // //     "/add-services",
// // //     "/customers",
// // //     "/feedback",
// // //     "/settings",
// // //     "/employee-dashboard",
// // //     "/work",
// // //     "/assigned-work",
// // //     "/worked",
// // //   ];

// // //   const shouldHideNav = hideNavPaths.some(path => location.pathname.startsWith(path));

// // //   return (
// // //     <>
// // //       {!shouldHideNav && <Nav />}
// // //       {children}
// // //     </>
// // //   );
// // // }

// // // function App() {
// // //   return (
// // //     <Router>
// // //       <ScrollToTop />
// // //       <LayoutWrapper>
// // //         <div className="main-content" style={{ paddingTop: "70px" }}>
// // //           <Suspense fallback={<div className="loader">Loading...</div>}>
// // //             <Routes>
// // //               {/* ================== Main User Routes ================== */}
// // //               <Route path="/" element={<Home />} />
// // //               <Route path="/servicehome" element={<ServiceHome />} />
// // //               {/* ... all other public routes */}

// // //               {/* ================== Admin / Employee Routes ================== */}
// // //               <Route path="/admin-login" element={<LoginPage />} />
// // //               <Route
// // //                 path="/admin-dashboard"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <Dashboard />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/orders"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <OrdersPage />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/employees"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <EmployeesPage />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/AddAdmin"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <AddAdmin />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/add-services"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <AddServicesPage />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/customers"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <CustomersPage />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/feedback"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <FeedbackPage />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/settings"
// // //                 element={
// // //                   <ProtectedRoute type="owner">
// // //                     <SettingsPage />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />

// // //               {/* Employee Routes */}
// // //               <Route
// // //                 path="/employee-dashboard"
// // //                 element={
// // //                   <ProtectedRoute type="employee">
// // //                     <EmployeeDashboard />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/work"
// // //                 element={
// // //                   <ProtectedRoute type="employee">
// // //                     <AssignedWork />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/assigned-work/:id"
// // //                 element={
// // //                   <ProtectedRoute type="employee">
// // //                     <AssignedWorkDetail />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //               <Route
// // //                 path="/worked"
// // //                 element={
// // //                   <ProtectedRoute type="employee">
// // //                     <Workcompleted />
// // //                   </ProtectedRoute>
// // //                 }
// // //               />
// // //             </Routes>
// // //           </Suspense>
// // //         </div>
// // //       </LayoutWrapper>
// // //     </Router>
// // //   );
// // // }

// // // export default App;



// // import React, { Suspense, lazy } from "react";
// // import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// // import ScrollToTop from "./components/ScrollToTop";
// // import Modal from "react-modal";
// // import Nav from "./components/Nav";
// // import Footer from "./components/footer";

// // // Admin/Employee imports
// // import LoginPage from "./component/LoginPage";
// // import Dashboard from "./component/Dashboard";
// // import OrdersPage from "./component/OrdersPage/OrdersPage";
// // import AddServicesPage from "./component/AddServicesPage/AddServicesPage";
// // import CustomersPage from "./component/CustomersPage/CustomersPage";
// // import FeedbackPage from "./component/FeedbackPage/FeedbackPage";
// // import SettingsPage from "./component/SettingsPage/SettingsPage";
// // import EmployeesPage from "./component/EmployeesPage/EmployeesPage";
// // import EmployeeDashboard from "./component/EmployeeDashboard/EmployeeDashboard";
// // import AssignedWork from "./component/EmployeeDashboard/Work/AssignedWork";
// // import Workcompleted from "./component/EmployeeDashboard/Work/Workcompleted";
// // import ProtectedRoute from "./component/ProtectedRoute";
// // import AssignedWorkDetail from "./component/EmployeeDashboard/Work/AssignedWorkDetail";
// // import AddAdmin from "./component/EmployeesPage/AddAdmin";

// // Modal.setAppElement("#root");

// // // Lazy load other pages
// // const Home = lazy(() => import("./pages/Home"));
// // const ServiceHome = lazy(() => import("./pages/servicehome"));
// // // ... (all other lazy imports remain same)

// // // Wrapper to conditionally render Nav
// // function LayoutWrapper({ children }) {
// //   const location = useLocation();

// //   // List of paths where Nav should NOT appear
// //   const hideNavPaths = [
// //     "/admin-login",
// //     "/admin-dashboard",
// //     "/orders",
// //     "/employees",
// //     "/AddAdmin",
// //     "/add-services",
// //     "/customers",
// //     "/feedback",
// //     "/settings",
// //     "/employee-dashboard",
// //     "/work",
// //     "/assigned-work",
// //     "/worked",
// //   ];

// //   const shouldHideNav = hideNavPaths.some(path => location.pathname.startsWith(path));

// //   return (
// //     <>
// //       {!shouldHideNav && <Nav />}
// //       {children}
// //     </>
// //   );
// // }

// // function App() {
// //   return (
// //     <Router>
// //       <ScrollToTop />
// //       <LayoutWrapper>
// //         <div className="main-content" style={{ paddingTop: "70px" }}>
// //           <Suspense fallback={<div className="loader">Loading...</div>}>
// //             <Routes>
// //               {/* ================== Main User Routes ================== */}
// //               <Route path="/" element={<Home />} />
// //               <Route path="/servicehome" element={<ServiceHome />} />
// //               {/* ... all other public routes */}

// //               {/* ================== Admin / Employee Routes ================== */}
// //               <Route path="/admin-login" element={<LoginPage />} />
// //               <Route
// //                 path="/admin-dashboard"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <Dashboard />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/orders"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <OrdersPage />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/employees"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <EmployeesPage />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/AddAdmin"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <AddAdmin />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/add-services"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <AddServicesPage />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/customers"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <CustomersPage />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/feedback"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <FeedbackPage />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/settings"
// //                 element={
// //                   <ProtectedRoute type="owner">
// //                     <SettingsPage />
// //                   </ProtectedRoute>
// //                 }
// //               />

// //               {/* Employee Routes */}
// //               <Route
// //                 path="/employee-dashboard"
// //                 element={
// //                   <ProtectedRoute type="employee">
// //                     <EmployeeDashboard />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/work"
// //                 element={
// //                   <ProtectedRoute type="employee">
// //                     <AssignedWork />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/assigned-work/:id"
// //                 element={
// //                   <ProtectedRoute type="employee">
// //                     <AssignedWorkDetail />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //               <Route
// //                 path="/worked"
// //                 element={
// //                   <ProtectedRoute type="employee">
// //                     <Workcompleted />
// //                   </ProtectedRoute>
// //                 }
// //               />
// //             </Routes>
// //           </Suspense>
// //         </div>
// //       </LayoutWrapper>
// //     </Router>
// //   );
// // }

// // export default App;





// import React, { Suspense, lazy } from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import ScrollToTop from "./components/ScrollToTop";
// import Modal from "react-modal";
// import Nav from "./components/Nav";
// import Footer from "./components/footer";

// // Admin/Employee imports
// import LoginPage from "./component/LoginPage";
// import Dashboard from "./component/Dashboard";
// import OrdersPage from "./component/OrdersPage/OrdersPage";
// import AddServicesPage from "./component/AddServicesPage/AddServicesPage";
// import CustomersPage from "./component/CustomersPage/CustomersPage";
// import FeedbackPage from "./component/FeedbackPage/FeedbackPage";
// import SettingsPage from "./component/SettingsPage/SettingsPage";
// import EmployeesPage from "./component/EmployeesPage/EmployeesPage";
// import EmployeeDashboard from "./component/EmployeeDashboard/EmployeeDashboard";
// import AssignedWork from "./component/EmployeeDashboard/Work/AssignedWork";
// import Workcompleted from "./component/EmployeeDashboard/Work/Workcompleted";
// import ProtectedRoute from "./component/ProtectedRoute";
// import AssignedWorkDetail from "./component/EmployeeDashboard/Work/AssignedWorkDetail";
// import AddAdmin from "./component/EmployeesPage/AddAdmin";

// // Lazy load user-facing pages
// const Home = lazy(() => import("./pages/Home"));
// const ServiceHome = lazy(() => import("./pages/servicehome"));
// const SavedLocations = lazy(() => import("./pages/SavedLocations"));
// const LocationPicker = lazy(() => import("./pages/LocationPicker"));
// const ChangeLocationManually = lazy(() => import("./pages/ChangeLocationManually"));
// const ChangeLocation = lazy(() => import("./pages/ChangeLocation"));
// const SubHome = lazy(() => import("./pages/SubHome"));
// const OfferCard = lazy(() => import("./pages/OfferCards"));
// const OfferCard2 = lazy(() => import("./pages/OfferCard2"));
// const AllSubServices = lazy(() => import("./pages/AllSubServices"));
// const ServiceDetails = lazy(() => import("./pages/ServiceDetails"));
// const Login = lazy(() => import("./pages/Login"));
// const TermsAnsConditions = lazy(() => import("./pages/TermsAnsConditions"));
// const HelpSupports = lazy(() => import("./pages/HelpSupports"));
// const Specialoffer = lazy(() => import("./pages/Specialoffer"));

// // About
// const CompanyOverview = lazy(() => import("./pages/About/CompanyOverview"));
// const Leadership = lazy(() => import("./pages/About/Leadership"));

// // Like system
// const LikePage = lazy(() => import("./pages/Like/LikePage"));
// const LikedPage = lazy(() => import("./pages/Like/LikedPage"));
// const CartPage = lazy(() => import("./pages/Like/CartPage"));
// const OrdersPageMain = lazy(() => import("./pages/Like/OrdersPageMain"));
// const CompletedOrdersPage = lazy(() => import("./pages/Like/CompletedOrdersPage"));

// // Profile system
// const Profile = lazy(() => import("./pages/Profile/Profile"));
// const OrdersPagep = lazy(() => import("./pages/Profile/OrdersPagep"));
// const Cartp = lazy(() => import("./pages/Profile/Cartp"));
// const LikedPagep = lazy(() => import("./pages/Profile/LikedPagep"));
// const Couponsp = lazy(() => import("./pages/Profile/Couponsp"));
// const Wallet = lazy(() => import("./pages/Profile/Wallet"));
// const Wishlist = lazy(() => import("./pages/Profile/Wishlist"));
// const EditProfile = lazy(() => import("./pages/Profile/EditProfile"));
// const HelpSupport = lazy(() => import("./pages/Profile/HelpSupport"));
// const PrivacyPolicy = lazy(() => import("./pages/Profile/PrivacyPolicy"));

// Modal.setAppElement("#root");

// // Wrapper to hide Nav on admin/employee pages
// function LayoutWrapper({ children }) {
//   const location = useLocation();

//   const hideNavPaths = [
//     "/admin-login",
//     "/admin-dashboard",
//     "/orders",
//     "/employees",
//     "/AddAdmin",
//     "/add-services",
//     "/customers",
//     "/feedback",
//     "/settings",
//     "/employee-dashboard",
//     "/work",
//     "/assigned-work",
//     "/worked",
//   ];

//   const shouldHideNav = hideNavPaths.some(path =>
//     location.pathname.startsWith(path)
//   );

//   return (
//     <>
//       {!shouldHideNav && <Nav />}
//       {children}
//     </>
//   );
// }

// function App() {
//   return (
//     <Router>
//       <ScrollToTop />
//       <LayoutWrapper>
//         <div className="main-content" style={{ paddingTop: "70px" }}>
//           <Suspense fallback={<div className="loader">Loading...</div>}>
//             <Routes>
//               {/* ================== User Routes ================== */}
//               <Route path="/" element={<Home />} />
//               <Route path="/servicehome" element={<ServiceHome />} />
//               <Route path="/Address" element={<SavedLocations />} />
//               <Route path="/LocationPicker" element={<LocationPicker />} />
//               <Route path="/ChangeLocationManually" element={<ChangeLocationManually />} />
//               <Route path="/ChangeLocation" element={<ChangeLocation />} />
//               <Route path="/subhome/:category" element={<SubHome />} />
//               <Route path="/offercard" element={<OfferCard />} />
//               <Route path="/offercard2/:offerId" element={<OfferCard2 />} />
//               <Route path="/allservices" element={<AllSubServices />} />
//               <Route path="/allservices/:offer_id" element={<ServiceDetails />} />
//               <Route path="/login" element={<Login />} />
//               <Route path="/termsandconditions" element={<TermsAnsConditions />} />
//               <Route path="/HelpSupports" element={<HelpSupports />} />
//               <Route path="/specialoffer" element={<Specialoffer />} />

//               {/* About */}
//               <Route path="/about/company" element={<CompanyOverview />} />
//               <Route path="/about/leadership" element={<Leadership />} />

//               {/* Like system */}
//               <Route path="/like" element={<LikePage />} />
//               <Route path="/like/liked" element={<LikedPage />} />
//               <Route path="/like/cart" element={<CartPage />} />
//               <Route path="/like/orders" element={<OrdersPageMain />} />
//               <Route path="/like/completedorders" element={<CompletedOrdersPage />} />

//               {/* Profile routes */}
//               <Route path="/profile" element={<Profile />}>
//                 <Route path="orders" element={<OrdersPagep />} />
//                 <Route path="cart" element={<Cartp />} />
//                 <Route path="liked" element={<LikedPagep />} />
//                 <Route path="coupons" element={<Couponsp />} />
//                 <Route path="wallet" element={<Wallet />} />
//                 <Route path="wishlist" element={<Wishlist />} />
//                 <Route path="editprofile" element={<EditProfile />} />
//                 <Route path="support" element={<HelpSupport />} />
//                 <Route path="privacy" element={<PrivacyPolicy />} />
//                 <Route path="footer" element={<Footer />} />
//                 <Route path="changelocation" element={<ChangeLocation />} />
//               </Route>

//               {/* ================== Admin / Owner Routes ================== */}
//               <Route path="/admin-login" element={<LoginPage />} />
//               <Route
//                 path="/admin-dashboard"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <Dashboard />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/orders"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <OrdersPage />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/employees"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <EmployeesPage />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/AddAdmin"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <AddAdmin />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/add-services"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <AddServicesPage />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/customers"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <CustomersPage />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/feedback"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <FeedbackPage />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/settings"
//                 element={
//                   <ProtectedRoute type="owner">
//                     <SettingsPage />
//                   </ProtectedRoute>
//                 }
//               />

//               {/* ================== Employee Routes ================== */}
//               <Route
//                 path="/employee-dashboard"
//                 element={
//                   <ProtectedRoute type="employee">
//                     <EmployeeDashboard />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/work"
//                 element={
//                   <ProtectedRoute type="employee">
//                     <AssignedWork />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/assigned-work/:id"
//                 element={
//                   <ProtectedRoute type="employee">
//                     <AssignedWorkDetail />
//                   </ProtectedRoute>
//                 }
//               />
//               <Route
//                 path="/worked"
//                 element={
//                   <ProtectedRoute type="employee">
//                     <Workcompleted />
//                   </ProtectedRoute>
//                 }
//               />
//             </Routes>
//           </Suspense>
//         </div>
//       </LayoutWrapper>
//     </Router>
//   );
// }

// export default App;






import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Modal from "react-modal";
import Nav from "./components/Nav";
import Footer from "./components/footer";

// Admin/Employee imports
import LoginPage from "./component/LoginPage";
import Dashboard from "./component/Dashboard";
import OrdersPage from "./component/OrdersPage/OrdersPage";
import AddServicesPage from "./component/AddServicesPage/AddServicesPage";
import CustomersPage from "./component/CustomersPage/CustomersPage";
import FeedbackPage from "./component/FeedbackPage/FeedbackPage";
import SettingsPage from "./component/SettingsPage/SettingsPage";
import EmployeesPage from "./component/EmployeesPage/EmployeesPage";
import EmployeeDashboard from "./component/EmployeeDashboard/EmployeeDashboard";
import AssignedWork from "./component/EmployeeDashboard/Work/AssignedWork";
import Workcompleted from "./component/EmployeeDashboard/Work/Workcompleted";
import ProtectedRoute from "./component/ProtectedRoute";
import AssignedWorkDetail from "./component/EmployeeDashboard/Work/AssignedWorkDetail";
import AddAdmin from "./component/EmployeesPage/AddAdmin";
import ChangeLocation from "./pages/subpages/ChangeLocation";
import OfferCards from "./pages/OfferCards";

const Home = lazy(() => import("./pages/Home"));
const ServiceHome = lazy(() => import("./pages/serviceHome"));
const SubHome = lazy(() => import("./pages/subhome"));
const OfferCard = lazy(() => import("./pages/OfferCards"));
const OfferCard2 = lazy(() => import("./pages/offercard2"));
const AllSubServices = lazy(() => import("./pages/AllSubServices"));
const ServiceDetails = lazy(() => import("./pages/ServiceDetails"));
const Login = lazy(() => import("./pages/Login"));

// ✅ Like system
const LikePage = lazy(() => import("./pages/Like"));
const LikedPage = lazy(() => import("./pages/Likes/LikedPage"));
const CartPage = lazy(() => import("./pages/Cart/Cart"));
const OrdersPageMain = lazy(() => import("./pages/Orders/Order"));
const CompletedOrdersPage = lazy(() =>
  import("./pages/CompletedOrder/CompletedOrders")
);

// ✅ Profile system
const Profile = lazy(() => import("./pages/Profile"));
const Wallet = lazy(() => import("./pages/profile/Wallet"));
const Wishlist = lazy(() => import("./pages/profile/Wishlist"));
const Coupons = lazy(() => import("./pages/profile/Coupons"));
const EditProfile = lazy(() => import("./pages/profile/EditProfile"));
const HelpSupport = lazy(() => import("./pages/profile/HelpSupport"));
const PrivacyPolicy = lazy(() => import("./pages/profile/PrivacyPolicy"));
const SavedLocations = lazy(() => import("./pages/subpages/SavedLocations"));
const LocationPicker = lazy(() => import("./pages/subpages/LocationPicker"));
const ChangeLocationManually = lazy(() => import("./pages/subpages/ChangeLocationManually"));
const Cartp = lazy(() => import("./pages/profile/Cartp"));

const Couponsp = lazy(() => import("./pages/profile/Couponsp"));
const ClickTocall = lazy(() => import("./pages/profile/ClickTocall"));
const SpecialOffer = lazy(() => import("./pages/Specialoffer"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const HelpSupports = lazy(() => import("./pages/HelpSupports"));



// ✅ Subpages (About section)
const CompanyOverview = lazy(() => import("./Subpages/CompanyOverview"));
const Leadership = lazy(() => import("./Subpages/Leadership"));

Modal.setAppElement("#root");

// Wrapper to hide Nav on admin/employee pages
function LayoutWrapper({ children }) {
  const location = useLocation();

  const hideNavPaths = [
    "/admin-login",
    "/admin-dashboard",
    "/orders",
    
    "/employees",
    "/AddAdmin",
    "/add-services",
    "/customers",
    "/feedback",
    "/settings",
    "/employee-dashboard",
    "/work",
    "/assigned-work",
    "/worked",
  ];

  const shouldHideNav = hideNavPaths.some(path =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      {!shouldHideNav && <Nav />}
      {children}
    </>
  );
}
// style={{ paddingTop: "50px" }}
function App() {
  return (
    <Router>
      <ScrollToTop />
      <LayoutWrapper>
        <div className="main-content" >
          <Suspense fallback={<div className="loader">Loading...</div>}>
            <Routes>
              {/* ================== User Routes ================== */}
              <Route path="/" element={<Home />} />
              <Route path="/servicehome" element={<ServiceHome />} />
              <Route path="/Address" element={<SavedLocations />} />
              <Route path="/LocationPicker" element={<LocationPicker />} />
              <Route path="/ChangeLocationManually" element={<ChangeLocationManually />} />
              <Route path="/ChangeLocation" element={<ChangeLocation />} />
              <Route path="/subhome/:category" element={<SubHome />} />
              <Route path="/offercard" element={<OfferCards />} />
              <Route path="/offercard2/:offerId" element={<OfferCard2 />} />
              <Route path="/allservices" element={<AllSubServices />} />
              <Route path="/allservices/:offer_id" element={<ServiceDetails />} />
              <Route path="/login" element={<Login />} />
              <Route path="/termsandconditions" element={<TermsAndConditions />} />
              <Route path="/HelpSupports" element={<HelpSupports />} />
              <Route path="/specialoffer" element={<SpecialOffer />} />

              {/* About */}
              <Route path="/about/company" element={<CompanyOverview />} />
              <Route path="/about/leadership" element={<Leadership />} />

              {/* Like system */}
              <Route path="/like" element={<LikePage />} />
              <Route path="/like/liked" element={<LikedPage />} />
              <Route path="/like/cart" element={<CartPage />} />
              <Route path="/like/orders" element={<OrdersPageMain />} />
              <Route path="/like/completedorders" element={<CompletedOrdersPage />} />

              {/* Profile routes */}
              <Route path="/profile" element={<Profile />}>
                <Route path="orders" element={<OrdersPage />} />
                <Route path="cart" element={<Cartp />} />
                <Route path="liked" element={<LikedPage />} />
                <Route path="coupons" element={<Coupons />} />
                <Route path="clicktocall" element={<ClickTocall />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="wishlist" element={<Wishlist />} />
                <Route path="editprofile" element={<EditProfile />} />
                <Route path="support" element={<HelpSupport />} />
                <Route path="privacy" element={<PrivacyPolicy />} />
                <Route path="footer" element={<Footer />} />
                <Route path="changelocation" element={<ChangeLocation />} />
              </Route>

              {/* ================== Admin / Owner Routes ================== */}
              <Route path="/admin-login" element={<LoginPage />} />
              <Route
                path="/admin-dashboard"
                element={
                  <ProtectedRoute type="owner">
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute type="owner">
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/employees"
                element={
                  <ProtectedRoute type="owner">
                    <EmployeesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddAdmin"
                element={
                  <ProtectedRoute type="owner">
                    <AddAdmin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/add-services"
                element={
                  <ProtectedRoute type="owner">
                    <AddServicesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <ProtectedRoute type="owner">
                    <CustomersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/feedback"
                element={
                  <ProtectedRoute type="owner">
                    <FeedbackPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute type="owner">
                    <SettingsPage />
                  </ProtectedRoute>
                }
              />

              {/* ================== Employee Routes ================== */}
              <Route
                path="/employee-dashboard"
                element={
                  <ProtectedRoute type="employee">
                    <EmployeeDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/work"
                element={
                  <ProtectedRoute type="employee">
                    <AssignedWork />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/assigned-work/:id"
                element={
                  <ProtectedRoute type="employee">
                    <AssignedWorkDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/worked"
                element={
                  <ProtectedRoute type="employee">
                    <Workcompleted />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Suspense>
        </div>
      </LayoutWrapper>
    </Router>
  );
}

export default App;
